<!--~
  ~ Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div class="file-upload">
    <div fxLayout="column"
         fxLayoutAlign="space-around start">
        <div *ngIf='maxFiles == 1'
             class="file-upload-instructions">
            Select a file to upload, or drag and drop a file here
        </div>
        <div *ngIf='maxFiles > 1'
             class="file-upload-instructions">
            Select up to {{maxFiles}} files to upload, or drag and drop file(s) here
        </div>
        <button mat-flat-button color="primary" (click)="fileInput.click()" [disabled]='disabled'>Select files:</button>
        <input type="file" id="fileInput"
               hidden #fileInput
               (change)="inputFieldChange($event)"
               [accept]="accept"
               [multiple]="maxFiles > 1"
               [disabled]='disabled'
               class="upload-file-input"/>
    </div>
    <div fxFill fxLayout="column" #dropTarget
         fxLayoutAlign="center center"
         class="file-drop-target"
         [style.visibility]="isDraggingOver ? 'visible' : 'hidden'">
        <div>Drop files here</div>
    </div>
</div>
